var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { createSlice } from '@reduxjs/toolkit';
import { dealsSliceName } from './consts';
import { DEFAULT_FETCH_STATUS, getFailedFetchStatus, getSuccessfulFetchStatus, } from '../../utils/fetchStatus';
import { claimOffer, fetchDeal } from './thunks';
var INITIAL_STATE = {
    items: {},
    aliases: {},
};
var getId = function (aliases, action) {
    var _a;
    var idOrAlias = action.meta.arg;
    return (_a = aliases[idOrAlias]) !== null && _a !== void 0 ? _a : idOrAlias;
};
export var dealsSlice = createSlice({
    name: dealsSliceName,
    initialState: INITIAL_STATE,
    reducers: {},
    extraReducers: function (builder) {
        return builder
            .addCase(fetchDeal.pending, function (state, action) {
            var id = getId(state.aliases, action);
            if (state.items[id]) {
                state.items[id].fetchingInProgressSince = Date.now();
            }
            else {
                state.items[id] = __assign(__assign({}, DEFAULT_FETCH_STATUS), { fetchingInProgressSince: Date.now() });
            }
        })
            .addCase(fetchDeal.rejected, function (state, action) {
            var id = getId(state.aliases, action);
            var _a = state.items[id], deal = _a.deal, fetchStatus = __rest(_a, ["deal"]);
            state.items[id] = __assign({ deal: deal }, getFailedFetchStatus(fetchStatus));
        })
            .addCase(fetchDeal.fulfilled, function (state, action) {
            var id = getId(state.aliases, action);
            var _a = state.items[id], _ = _a.deal, fetchStatus = __rest(_a, ["deal"]);
            var deal = action.payload.dealArea;
            var wasAliasUsed = id === deal.urlAlias;
            if (wasAliasUsed) {
                delete state.items[id];
            }
            state.aliases[deal.urlAlias] = deal._id;
            state.items[action.payload.dealArea._id] = __assign({ deal: action.payload }, getSuccessfulFetchStatus(fetchStatus));
        })
            .addCase(claimOffer.fulfilled, function (state, action) {
            var _a, _b, _c;
            var code = action.payload.code, offerId = action.meta.arg;
            var groupHasOffer = function (group) {
                return group.offers.some(function (offer) { return offer._id === offerId; });
            };
            var deal = (_a = Object.values(state.items).find(function (dealState) { var _a, _b, _c; return (_c = (_b = (_a = dealState.deal) === null || _a === void 0 ? void 0 : _a.dealArea) === null || _b === void 0 ? void 0 : _b.offerGroups) === null || _c === void 0 ? void 0 : _c.some(groupHasOffer); })) === null || _a === void 0 ? void 0 : _a.deal;
            if (deal) {
                var wasAlreadyClaimed = (_b = deal.claimedCodes) === null || _b === void 0 ? void 0 : _b.some(function (_a) {
                    var dealOffer = _a.dealOffer;
                    return dealOffer === offerId;
                });
                if (!wasAlreadyClaimed) {
                    deal.claimedCodes = __spreadArray(__spreadArray([], ((_c = deal.claimedCodes) !== null && _c !== void 0 ? _c : []), true), [
                        { code: code, dealOffer: offerId },
                    ], false);
                }
            }
        })
            .addCase('LOGOUT_SUCCESSFUL', function (state) {
            Object.values(state.items).forEach(function (item) {
                if (item.deal) {
                    item.deal.claimedCodes = undefined;
                }
            });
        })
            .addMatcher(function (action) {
            return action.type === 'SET_LANGUAGE' || action.type === 'LOGIN_SUCCESSFUL';
        }, function (state) {
            Object.values(state.items).forEach(function (item) {
                item.didInvalidate = true;
            });
        });
    },
});
export default (_a = {}, _a[dealsSliceName] = dealsSlice.reducer, _a);
